/* System defined core library */
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { AppointmentService } from '../../services/appointment/appointment.service';
import { SelectedExamDetailService } from '../../services/selected-exam-detail.service';

/* User defined models */
import { Exam } from '../../../../shared/models/scheduling/exam.model';

/* User defined enums/constants */
import { ExamStatus } from '../../../../shared/enums/scheduling.enum';

@Component({
  selector: 'app-exam-card',
  templateUrl: './exam-card.component.html',
  styleUrls: ['./exam-card.component.scss']
})
export class ExamCardComponent implements OnInit {

  @Input() examObj: Exam;

  /* User defined private/public variables  */
  public examDetail: Exam;
  public duration: string;
  public selectedTranslateLanguage: string = "";
  public startDate: string;
  public endDate: string;

  /* Service subscriptions */
  translateLanguage$: Subscription;

  /* Constructor declaration with required injected services */
  constructor(
    private appointmentService: AppointmentService,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService
  ) {

    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      });
  }

  /* Initialize the component & call require methods when component loaded first time. */
  ngOnInit(): void {
    this.examDetail = this.examObj;
    if (this.examDetail && this.examDetail.startDate) {
      this.startDate = moment(this.examDetail.startDate).format('DD MMMM YYYY');
    }

    if (this.examDetail && this.examDetail.endDate) {
      this.endDate = moment(this.examDetail.endDate).format('DD MMMM YYYY');
    }

    // commenting out this for now as duration returned
    // from registration service does not have TA added - MM
    //if (this.examDetail.duration) {
    //    this.duration = this.utilityService.durationToStr(this.examDetail.duration);
    //}
  }

  /* Display error if not schedulable using current modality. If an exam does not have the internet schedule method it should display that error instead of modality. */
  showModalityError(): boolean {
    return !this.appointmentService.canScheduleExamInFlow(this.examDetail) && this.examDetail.status !== ExamStatus.InvalidSchedulingMethod.toString();
  }
}
